import React, { Component } from "react";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import NumberFormat from "react-number-format";

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

// CSS
import "../../../css/display-table.css";

class TopSellers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataLoaded: false,
			data: null,
			error: ""
		};
	}

	componentDidMount() {
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token };
		return axios
			.get(REACT_APP_API_URL + "summary/top-sellers?order=" + this.props.sort, { headers: AUTH_HEADER })
			.then(response => {
				if (response.status !== 200) {
					this.setState({ dataLoaded: true, error: response.data.message });
				} else {
					this.setState({ dataLoaded: true, data: { ...response.data } });
				}
			})
			.catch(err => {
				this.setState({ dataLoaded: true, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
			});
	}

	showData() {
		const { sort } = this.props;

		if (sort === "sku") {
			return (
				<React.Fragment>
					{this.state.dataLoaded ? (
						<React.Fragment>
							<h2>Top Products - Times Purchased</h2>
							{!isEmpty(this.state.data) ? (
								<table className="display_table light_table">
									<thead>
										<tr className="table-header">
											<th />
											<th>Sku</th>
											<th className="right_aligned">Total Purchased</th>
										</tr>
									</thead>
									<tbody>
										{Object.keys(this.state.data).map(key => (
											<tr key={key}>
												<td className="record-number">{1 + parseInt(key, 10)}</td>
												<td data-id="Sku">{this.state.data[key].sku}</td>
												<td data-id="Times Purchased" className="right_aligned">
													{this.state.data[key].sku_count}
												</td>
											</tr>
										))}
									</tbody>
								</table>
							) : (
								<div>There are no products at this time!</div>
							)}
						</React.Fragment>
					) : null}
				</React.Fragment>
			);
		} else if (sort === "revenue") {
			return (
				<React.Fragment>
					{this.state.dataLoaded ? (
						<React.Fragment>
							<h2>Top Products - Times Purchased</h2>
							{!isEmpty(this.state.data) ? (
								<table className="display_table light_table">
									<thead>
										<tr className="table-header">
											<th />
											<th>Sku</th>
											<th className="right_aligned">Total Purchased</th>
										</tr>
									</thead>
									<tbody>
										{Object.keys(this.state.data).map(key => (
											<tr key={key}>
												<td className="record-number">{1 + parseInt(key, 10)}</td>
												<td data-id="Sku">{this.state.data[key].sku}</td>
												<td data-id="Times Purchased" className="right_aligned">
													<NumberFormat value={this.state.data[key].total_price} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
												</td>
											</tr>
										))}
									</tbody>
								</table>
							) : (
								<div>There are no products at this time!</div>
							)}
						</React.Fragment>
					) : null}
				</React.Fragment>
			);
		}
	}

	render() {
		return (
			<div className="chart_area chart_1_2">
				{this.state.error && (
					<div className="error">
						{Object.keys(this.state.error).map(key => (
							<span key={key}>{this.state.error[key]}</span>
						))}
					</div>
				)}
				{this.state.data && this.showData()}
			</div>
		);
	}
}

TopSellers.defaultProps = {
	sort: "sku"
};

export default TopSellers;



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/TopSellers.js